import React from "react";
import "./stat.styles.scss";
import salesIllustration from '../../../assets/images/salesIllustrate.svg'
import { connect } from "react-redux";
export const SalesExecutive = ({ firstName }) => {
  return (
    <>
      <div className="container">
        <div
          className="container-fluid welcome-head grid grid-cols-2 h-44 text-white mt-4 "
        >
          <div className="p-4">
            <h2>
              Hi, <strong>{firstName}</strong>
            </h2>
            <p className="text-lg">
              <span></span> Welcome to your <strong>{localStorage.getItem("companyName")}</strong>{" "}
              dashboard{" "} <br />  <span className="italic text-sm">...Let's make more sales today.</span>
            </p>
          </div>

          <div className="h-full w-full p-2">
            <img src={salesIllustration} alt=""className="h-40" />
          </div>

        </div>

        <div className="container-fluid mt-3">
          <div className="row">
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white homeCard mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="text-primary m-0">
                    {" "}
                    <strong> Sales YTD</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("salesYearToDate")} </strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong>Sales MTD</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("salesMonthToDate")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong>Sales WTD</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong>{localStorage.getItem("salesWeekToDate")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className=" m-0 text-primary">
                    {" "}
                    <strong>Today Sales</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong>{localStorage.getItem("salesToday")}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* </div> */}
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    firstName: state.userReducer.firstName,
  };
}
const mapDispatchToProps = (dispatch) => ({
  UpdateUser(payload) {
    dispatch({ type: "UPDATE_USER", payload });
  },

  LoadUsers(payload) {
    dispatch({ type: "LOAD_USERS", payload });
  },
  AddUser(payload) {
    dispatch({ type: "ADD_USER", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SalesExecutive);
